export var createApiKeysApi = function (baseUrl, http) {
    return {
        getApiKeys: function () { return http.get("".concat(baseUrl, "/apiKeys")); },
        getApiKey: function (id) { return http.get("".concat(baseUrl, "/apiKeys/").concat(id)); },
        addApiKey: function (dto) { return http.post("".concat(baseUrl, "/apiKeys"), dto); },
        updateApiKey: function (dto) { return http.put("".concat(baseUrl, "/apiKeys/").concat(dto.id), dto.data); },
        deleteApiKey: function (id) { return http.delete("".concat(baseUrl, "/apiKeys/").concat(id)); }
    };
};
//# sourceMappingURL=index.js.map